<template>
    <router-view />
</template>

<style>
@import "ui/styles/variables.css";

#app {
    font-family: Silkscreen, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}

@font-face {
    font-family: "Silkscreen";
    src: url("@/ui/assets/fonts/Silkscreen-Regular.ttf");
}
</style>
